import { useState, useEffect } from "react";
import MediaAssets from "assets";
import styles from "./SoldoutProjects.module.css";
import { useSelector } from "react-redux";
import { RouteConfigurations } from "routes/RouteConfigurations";
import { useNavigate } from "react-router-dom";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import DesktopCommonSlider from "components/desktop-common-slider/DesktopCommonSlider";
import MobileCommonSlider from "pages/mobile-common-slider/MobileCommonSlider";
import { LazyLoadImage } from "react-lazy-load-image-component";

const SoldoutProjects = () => {
  const [stopAutoPlay, setStopAutoPlay] = useState<boolean>(true);

  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 2000) {
        setStopAutoPlay(false);
      } else {
        setStopAutoPlay(true);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const projectDetails = useSelector((state: any) => {
    return state?.preLoginPageManagement?.investmentDetails
      ?.pageManagementsOrCollectionTwoModels;
  });
  const page = useSelector((state: any) => {
    return state?.preLoginPageManagement?.investmentDetails?.page;
  });

  const filterBasedOnpriorty = projectDetails
    // ?.sort((a: any, b: any) => a.priority - b.priority)
    ?.filter((element: any, index: number) => {
      if (index < page?.collectionTwo?.totalProjectContentsToDisplay) {
        return element;
      }
    });
  // console.log("collectionTwo page", page);
  // console.log("collectionTwo projectDetails", projectDetails);
  // console.log("collectionTwo filterBasedOnpriorty", filterBasedOnpriorty);

  const collectionTwoHeading = useSelector((state: any) => {
    return state?.preLoginPageManagement?.investmentDetails?.page?.collectionTwo
      ?.heading;
  });

  const { investmentData, pageData, newLaunches, newInvestmentsWithPriority } =
    useSelector((state: any) => ({
      investmentData:
        state?.newLaunch?.newLaunchData?.pageManagementsOrNewInvestments,
      pageData: state?.newLaunch?.newLaunchData?.page?.newInvestments,
      newInvestmentsWithPriority:
        state?.newLaunch?.newLaunchData?.page?.newInvestmentsWithPriority,
      newLaunches: state?.newLaunch?.newLaunchData,
    }));

  const handleRedirect = (data: any) => {
    navigate(`/investment-details/${data.launchName.replace(/%20|\s/g, "-")}`, {
      state: {
        projectId: data.id,
        area: data?.address?.area,
        cost: data.priceStartingFrom,
        title: data.launchName,
        location: data.address.city,
        description: data.shortDescription,
        isDetailed: data.isSoldOut,
        isExplore: data.isSoldOut,
        isSold: data.isSoldOut,
        dataAsObject: data,
        // medias: medias[index],
      },
    });
  };
  if (!page?.isCollectionTwoActiveForWeb || page?.collectionTwo?.status === "1002") {
    return <></>;
  }
  return projectDetails?.length > 0 ? (
    <>
      <div className={styles.banner_container}>
        <div className={styles.top_div_style}>
          <div className={styles.slider_icon_style}>
            {/* <img src={MediaAssets.explore_icon} /> */}
          </div>
          <h4 className={styles.heading_style}>
            {projectDetails?.length > 0 ? collectionTwoHeading : null}{" "}
          </h4>
          <div
            className={styles.slider_div_btn}
            style={{ color: "white" }}
            onClick={() => {
              navigate(RouteConfigurations.investments);
            }}
          >
            {projectDetails?.length > 0 ? "VIEW ALL PROJECTS" : null}
            <LazyLoadImage
              src={MediaAssets.arrow_left}
              style={{ marginLeft: "4px" }}
            />
          </div>
        </div>

        <div className={styles.forDesktop}>
          <DesktopCommonSlider sliderData={filterBasedOnpriorty} />
        </div>

        <div className={styles.forMobile}>
          <MobileCommonSlider sliderData={filterBasedOnpriorty} />
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

export default SoldoutProjects;
